import { NEW_CAR_CONFIGURATION_DEFAULT } from "../../../helpers/constants";
import { car } from "redux/actions";

export const $_GET = (key, def) => {
  if (def===undefined) {
    def=false;
  }

  let p = window.location.href;
  p = p.replace(/#\w+$/, '');
  p = p.match(new RegExp(key + '=([^&=]+)'));
  return p ? p[1] : def;
}

export const getDefaultConfigurationForCurrentModel = (
  configuration,
  allConfigs
) => {
  let config = false;

  if (
    configuration == NEW_CAR_CONFIGURATION_DEFAULT &&
    allConfigs &&
    allConfigs.length
  ) {
    config = allConfigs[0];
    car.update({ price: config.price, initial_fee_money: config.price / 2 });
  }

  return config;
};
